/*
 * @Author: Chenhw2017 1272617071@qq.com
 * @Date: 2024-07-18 14:02:42
 * @LastEditors: Chenhw2017 1272617071@qq.com
 * @LastEditTime: 2024-08-09 10:21:36
 * @FilePath: /seller.sviptrader.com/src/utils/hotfresh/index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue';
import axios from 'axios';
import { getHotFreshList } from '@/api/common';
import { getCache, setCache, clearCache } from './cache';
import { Matcher } from './matcher';
export const getHotFresh = async () => {
	try {
		let platRules = [];
		const currentPageVersion = sessionStorage.getItem('CURRENT_PAGE_VERSION');
		if (!currentPageVersion) return [];
		const res = await getHotFreshList({
			open: 1,
			versionTime: Math.floor(new Date(currentPageVersion).getTime() / 1000),
			applicationId: 1,
		});
		res.data.forEach(item => {
			platRules.push(...item.rules);
		});
		return platRules;
	} catch (error) {
		return [];
	}
};

export const getHotFreshData = async noCache => {
	const cache = getCache();
	if (!noCache && cache) {
		return {
			rules: cache,
			fromCache: true,
		};
	} else {
		const data = await getHotFresh();
		setCache(data);
		return {
			rules: data,
			fromCache: false,
		};
	}
};
let matcher = null;

export const isNeedHotFresh = async (api, route, noCache = false) => {
	// 防止循环调用自己
	if (api === '/miniprogram-batch-nestjs/hot-fresh/config/list') {
		return false;
	}
	try {
		const { rules, fromCache } = await getHotFreshData(noCache);
		if (!rules || !rules.length) return;
		if (!fromCache || !matcher) {
			matcher = new Matcher(rules);
		}
		let isRefresh = matcher.match(api, route);
		// 二次确认 防止规则的发布时间比最新版本时间晚，导致重复触发热更新规则
		if (isRefresh) {
			const { update } = await checkVersion();
			isRefresh = update;
		}
		return isRefresh;
	} catch (error) {
		return false;
	}
};

export const checkVersion = (payload = {}) => {
	let onlineVersion, onlineEtag;
	return new Promise(resolve => {
		// 请求模糊匹配app.开头的文件, 并且禁止缓存
		axios
			.get('/js/app.*?v=' + new Date().getTime(), {
				headers: { 'Cache-Control': 'no-cache' },
				timeout: 2000,
				baseURL:
					process.env.NODE_ENV == 'production'
						? window.location.origin ||
						  window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
						: '/checkVersion',
			})
			.then(res => {
				onlineVersion = res.headers['last-modified'];
				onlineEtag = res.headers['etag'];
				const currentPageEtag = sessionStorage.getItem('CURRENT_PAGE_ETAG');
				resolve({ update: currentPageEtag !== onlineEtag });
			})
			.catch(err => {
				resolve({ update: false });
				console.log('checkVersion err', err);
			})
			.finally(() => {
				if (payload?.updateVersion) {
					sessionStorage.setItem('CURRENT_PAGE_VERSION', onlineVersion);
					sessionStorage.setItem('CURRENT_PAGE_ETAG', onlineEtag);
				}
			});
	});
};

export const handleHotFresh = async (api, route, noCache) => {
	const needFresh = await isNeedHotFresh(api, route, noCache);
	if (needFresh) {
		try {
			await Vue.prototype
				.$confirm('当前版本存在更新', '提示', {
					confirmButtonText: '刷新',
					type: 'warning',
					showCancelButton: false,
					showClose: false,
					closeOnClickModal: false,
					closeOnHashChange: false,
					closeOnPressEscape: false,
				})
				.then(() => {
					clearCache();
					location.reload();
				});
		} catch (error) {
			console.log('热更新失败', error);
		}
	}
};

export default {
	handleHotFresh,
	checkVersion,
};
